// Global Instructions Rule Applied!
import { buildFullUrl, getBackendBaseUrl } from '../../../core/utils/endpoints.ts'
import { API_ROUTES } from '../../../core/utils/endpoints.ts'

const BACKEND_BASE_URL = getBackendBaseUrl()

export interface CompanyHoldingsData {
  holdings: Record<string, unknown>[]
  transactionSummary: Record<string, unknown>[]
  transactionDetail: Record<string, unknown>[]
}

export interface FetchCompanyHoldingsDataResponse {
  data?: CompanyHoldingsData
  error?: string
}

export async function fetchCompanyHoldingsData(
  accountId: string,
  accessToken: string | null
): Promise<FetchCompanyHoldingsDataResponse> {
  try {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json'
    }
    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`
    }

    const response = await fetch(
      buildFullUrl(BACKEND_BASE_URL, API_ROUTES.COMPANIES.HOLDINGS_DATA, { id: accountId }),
      {
        method: API_ROUTES.COMPANIES.HOLDINGS_DATA.method,
        headers
      }
    )

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('Authentication failed - please log in again')
      }
      const errData = await response.json().catch(() => ({}))
      throw new Error((errData as { message?: string }).message || response.statusText)
    }

    const json = (await response.json()) as { data?: CompanyHoldingsData }
    return { data: json.data }
  } catch (e) {
    return {
      error: e instanceof Error ? e.message : 'Failed to fetch holdings data'
    }
  }
}
